import React from "react";
import { Button } from "@mui/material";
import Modal from "../ui/Modal";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const ConfirmationModal = ({
  show,
  onCancel,
  onConfirm,
  title = "Confirm Action",
  messages = [],
  confirmText = "CONFIRM",
  cancelText = "CANCEL",
  confirmColor = "error",
  cancelColor = "primary",
  isSubmitting = false,
  IconComponent,
  iconClassName,
}) => {
  if (!show) {
    return null;
  }

  const renderIcon = () => {
    if (!IconComponent) {
      return (
        <div className="w-16 h-16 bg-dangerLight rounded-full flex items-center justify-center">
          <DeleteOutlineIcon className="text-danger" sx={{ fontSize: "2.5rem" }} />
        </div>
      );
    }

    return <IconComponent className={iconClassName || "w-20 h-24"} />;
  };

  return (
    <Modal
      show={show}
      onClose={isSubmitting ? undefined : onCancel}
      header={null}
      footer={null}
      className="!rounded-2xl shadow !p-0"
      bodyClass="!p-0"
    >
      <div className="flex flex-col items-center px-5 sm:px-8 py-3 sm:py-6">
        <div className="mb-4">{renderIcon()}</div>

        <h2 className="text-xl font-bold text-content mb-3">{title}</h2>

        <div className="text-md font-medium text-content mb-4 text-center">
          {messages.map((line, index) => (
            <p key={index}>{line}</p>
          ))}
        </div>

        <div className="flex gap-3 w-full justify-center">
          <Button
            onClick={onConfirm}
            variant="contained"
            color={confirmColor}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Processing..." : confirmText}
          </Button>
          <Button
            onClick={onCancel}
            variant="contained"
            color={cancelColor}
            disabled={isSubmitting}
          >
            {cancelText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
